export enum ActionPhases {
  Startup = "Startup",
  Integration = "Integration",
  Verification = "Verification",
  Consolidation = "Consolidation",
  Completed = "Completed"
}

export enum EmailSendModes {
  Enabled,
  Disabled,
  Redirected,
  LoggedOnly
}

export enum PeriodType {
  Monthly,
  Weekly 
}

export enum DataTypes {
  String = "String",
  Int = "Int",
  Double = "Double",
  Boolean = "Boolean",
  Json = "Json",
  Html = "Html",
  EmailSendModes = "EmailSendModes",
  Text = "Text",
}

export enum ContractTurnoverReportSource {
  Unknown = "Unknown",
  ManualTurnover = "ManualTurnover",
  Integration = "Integration",
  Audit = "Audit"
}

export enum ContactRelationKinds {
  OperatorResponsible = "OperatorResponsible",
  OperatorIntegrationResponsible = "OperatorIntegrationResponsible",
  OperatorFinancialAlertReceiver = "OperatorFinancialAlertReceiver",
  OperatorIntegrationAlertReceiver = "OperatorIntegrationAlertReceiver",
  OperatorResponsibleManualTurnover = "OperatorResponsibleManualTurnover",
  IntegratorIntegrationResponsible = "IntegratorIntegrationResponsible",
  FirewallAdministrator = "FirewallAdministrator",
  Finance = "Finance",
  Internal = "Internal"
}

export enum ImporterConfigurationValueTypes {
  Default = 0,
  Bool = 5,
  Int = 10,
  Double = 20,
  DateTime = 30,
  String = 40,
  Url = 50,
  ListOfStringsByPipe = 60,  //a|b|c
  IPRangesByPipe = 70,  //1.2.3.4-7|2.3.4.5|3-6.4-7.5.7
  Folder = 80
}

export enum AlertTypes {
  DataQualityAlert = "DataQualityAlert",
  FeedbackAlert = "FeedbackAlert",
  HistoricalDataAlert = "HistoricalDataAlert",
  MissingDataAlert = "MissingDataAlert",
  MissingReplyAlert = "MissingReplyAlert",
}

export enum JobStatuses {
  Pending = "Pending",
  Reserved = "Reserved",
  InProgress = "InProgress",
  Completed = "Completed",
  Failed = "Failed",
  Cancelled = "Cancelled",
  CancelledFromFailure = "CancelledFromFailure",
  CancelledFromDependencyFailure = "CancelledFromDependencyFailure"
}

export enum DataGapStatus {
  MissingData = "MissingData",
  MissingReason = "MissingReason",
  Completed = "Completed"
}

export enum DataGapReason {
  ShopClosed = "ShopClosed",
  TechnicalIssue = "TechnicalIssue",
  NoSale = "NoSale"
}

export enum DataGapUpdateType {
  DataGapCreated = "DataGapCreated",
  NewDataGapMailSent = "NewDataGapMailSent",
  ReminderMailSent = "ReminderMailSent",
  DataGapResolved = "DataGapResolved",
  DataGapClosed = "DataGapClosed",
  CommandAccessed = "CommandAccessed",
  SetManualHandling = "SetManualHandling",
  ReasonUpdated = "ReasonUpdated"
}

export enum ManualTurnoverType {
  NotIntegrated,
  Consolidation,
  Reconsolidation
}

export enum TaskSourceType {
  OperatorStatusExpectedFinish = "OperatorStatusExpectedFinish"
}

export enum ActivitySourceType {
  OperatorActivity = "OperatorActivity",
  ShopActivity = "ShopActivity",
  DataGapIncidentActivity = "DataGapIncidentActivity",
  IntegratorActivity = "IntegratorActivity",
  PushActivity = "PushActivity"
}

export enum InsightsChartTypes {
  MetricCard = "MetricCard",
  LineChart = "LineChart",
  BarChart = "BarChart",
  DonutChart = "DonutChart",
  PolarChart = "PolarChart"
}

export enum InsightsOperation {
  Sum = "Sum"
}

export enum GroupingDimension {
  Hour = "Hour",
  Day = "Day",
  Weekday = "Weekday",
  Week = "Week",
  Month = "Month",
  Quarter = "Quarter",
  Year = "Year",
  PaymentType = "PaymentType",
  SalesChannel = "SalesChannel",
  ProductClass = "ProductClass",
  ProductFamily = "ProductFamily",
  ProductSegment = "ProductSegment",
  DiscountType = "DiscountType",
  Shop = "Shop",
  Location = "Location",
  ShopCategory = "ShopCategory",
  Operator = "Operator"
}

export enum JobType {
  ExtensionsClearJob = "ExtensionsClearJob",
  MappingValuesBuildJob = "MappingValuesBuildJob",
  ExtensionsBuildJob = "ExtensionsBuildJob",
  MappingInputOptionsBuildJob = "MappingInputOptionsBuildJob",
  MappingValuesCleanupJob = "MappingValuesCleanupJob",
  TimeZoneUpdateJob = "TimeZoneUpdateJob",
  ImporterJob = "ImporterJob",
  ImporterScheduleJob = "ImporterScheduleJob",
  ContractTurnoverCalculationJob = "ContractTurnoverCalculationJob",
  ContractTurnoverCheckJob = "ContractTurnoverCheckJob",
  ContractTurnoverExportJob = "ContractTurnoverExportJob",
  ServiceModeJob = "ServiceModeJob",
  SalesSaveJob = "SalesSaveJob",
  ManualTurnoverJob = "ManualTurnoverJob",
  ManualTurnoverReminderJob = "ManualTurnoverReminderJob",
  ContractRulesSyncJob = "ContractRulesSyncJob",
  AlertJob = "AlertJob",
  DataGapJob = "DataGapJob",
  ConsolidationJob = "ConsolidationJob",
  PushTurnoverTransferJob = "PushTurnoverTransferJob",
  PushErrorTransferJob = "PushErrorTransferJob",
  PushCleanupJob = "PushCleanupJob",
  PushConfigurationJob = "PushConfigurationJob"
}

export enum InstructionType {
  ContractImport = "ContractImport",
  TurnoverExport = "TurnoverExport"
}

export enum InstructionStatus {
  Pending = "Pending",
  InProgress = "InProgress",
  Completed = "Completed",
  Failed = "Failed",
  Abandoned = "Abandoned"
}

export enum PaymentFrequency {
  Weekly = "Weekly",
  Monthly = "Monthly",
  Quarterly = "Quarterly",
  BiAnnually = "BiAnnually",
  Annually = "Annually"
}

export enum SettlementProfile {
  Linear = "Linear"
}

export enum ContractLineType {
  BaseFee = "BaseFee",
  ConcessionFee = "ConcessionFee",
  MinimumFee = "MinimumFee",
  Prepayment = "Prepayment"
}

export enum ContractRuleType {
  Concession = "Concession",
  Transactions = "Transactions"
}

export enum ConcessionFeeType {
  Turnover = "Turnover",
  Quantities = "Quantities",
  NetTransactions = "NetTransactions"
}

export enum ConcessionFeeCondition {
  LessThan = "LessThan",
  GreaterThanOrEqualTo = "GreaterThanOrEqualTo"
}

export enum BaseFeeTypes {
  Fixed = "Fixed",
  Utility = "Utility"
}

export enum MinimumFeeType {
  Fixed = "Fixed",
  Pax = "Pax"
}

export enum MinimumFeeFrequency {
  Monthly = "Monthly",
  Yearly = "Yearly"
}

export enum AuditAction {
  Created = "Created",
  Modified = "Modified",
  Deleted = "Deleted",
  SoftDeleted = "SoftDeleted",
  Restored = "Restored"
}

export enum Permission {
  CompaniesRead = "CompaniesRead",
  CompaniesWrite = "CompaniesWrite",
  CentersRead = "CentersRead",
  CentersWrite = "CentersWrite",
  ManualReportingRead = "ManualReportingRead",
  ManualReportingWrite = "ManualReportingWrite",
  OperatorsRead = "OperatorsRead",
  OperatorsWrite = "OperatorsWrite",
  UsersRead = "UsersRead",
  UsersWrite = "UsersWrite",
  UserPermissionSetWrite = "UserPermissionSetWrite",
  FinalizePeriodRead = "FinalizePeriodRead",
  FinalizePeriodWrite = "FinalizePeriodWrite",
  FinalizePeriodInvoiceWrite = "FinalizePeriodInvoiceWrite",
  ContractsRead = "ContractsRead",
  ContractsWrite = "ContractsWrite",
  InvoiceRead = "InvoiceRead",
  InvoiceWrite = "InvoiceWrite",
  InvoiceConfigurationRead = "InvoiceConfigurationRead",
  InvoiceConfigurationWrite = "InvoiceConfigurationWrite",
  LocationsRead = "LocationsRead",
  LocationsWrite = "LocationsWrite",
  ContactsRead = "ContactsRead",
  ContactsWrite = "ContactsWrite",
  StatusTypesRead = "StatusTypesRead",
  StatusTypesWrite = "StatusTypesWrite",
  ShopCategoriesWrite = "ShopCategoriesWrite",
  SalesChannelsWrite = "SalesChannelsWrite",
  BrandsRead = "BrandsRead",
  BrandsWrite = "BrandsWrite",
  PermissionSetsRead = "PermissionSetsRead",
  PermissionSetsWrite = "PermissionSetsWrite",
  IntegratorsRead = "IntegratorsRead",
  IntegratorsWrite = "IntegratorsWrite",
  PosSystemsRead = "PosSystemsRead",
  PosSystemsWrite = "PosSystemsWrite",
}

export enum UtilityTypes {
  Electricity = "Electricity",
  Water = "Water",
  Heat = "Heat"
}

export enum AllowedIpType {
  Push = "Push",
  Sftp = "Sftp",
  Command = "Command"
}

export enum PushApiKeyType {
  Standard = "Standard",
  Support = "Support"
}